// =============================================================
// config.ts — 체인/환경 설정
//   .env(VITE_*) 로 오버라이드 가능. 기본은 BSC 메인넷.
// =============================================================

export interface ChainConfig {
  id: number;
  idHex: string;
  name: string;
  nativeCurrency: { name: string; symbol: string; decimals: number };
  rpc: string;
  explorer: string;
}

// VITE_CHAIN_ID = 56(메인넷) | 97(테스트넷). 기본 56.
const CHAIN_ID = Number(import.meta.env.VITE_CHAIN_ID ?? 56);

const BSC_MAINNET: ChainConfig = {
  id: 56,
  idHex: '0x38',
  name: 'BNB Smart Chain',
  nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  rpc: import.meta.env.VITE_RPC_URL ?? 'https://bsc-dataseed.binance.org',
  explorer: 'https://bscscan.com',
};

const BSC_TESTNET: ChainConfig = {
  id: 97,
  idHex: '0x61',
  name: 'BNB Smart Chain Testnet',
  nativeCurrency: { name: 'tBNB', symbol: 'tBNB', decimals: 18 },
  rpc: import.meta.env.VITE_RPC_URL ?? 'https://data-seed-prebsc-1-s1.binance.org:8545',
  explorer: 'https://testnet.bscscan.com',
};

export const CHAIN: ChainConfig = CHAIN_ID === 97 ? BSC_TESTNET : BSC_MAINNET;

// Reown(WalletConnect) Project ID — dashboard.reown.com 에서 발급
export const REOWN_PROJECT_ID: string = import.meta.env.VITE_REOWN_PROJECT_ID ?? '';

// 백엔드 API 베이스 (통합 서버라 기본 동일 출처)
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '';

// claim 컨트랙트 주소
export const CLAIM_CONTRACT: string = import.meta.env.VITE_CLAIM_CONTRACT ?? '';

// MOL 토큰(지급 대상) — claim 성공 후 지갑에 추가 제안용.
//  · 테스트넷=tMOL, 메인넷=MOL. .env 의 VITE_MOL_TOKEN 으로 지정.
export const MOL_TOKEN: string = import.meta.env.VITE_MOL_TOKEN ?? '';
export const MOL_SYMBOL: string = import.meta.env.VITE_MOL_SYMBOL ?? (CHAIN_ID === 97 ? 'tMOL' : 'MOL');
export const MOL_DECIMALS: number = Number(import.meta.env.VITE_MOL_DECIMALS ?? 18);

// ---- 소셜: 텔레그램 ----
export const TG_CHANNEL: string = import.meta.env.VITE_TG_CHANNEL ?? 'https://t.me/MolePin';
export const TG_GROUP: string = import.meta.env.VITE_TG_GROUP ?? 'https://t.me/molepinchat';
export const TG_BOT_USERNAME: string = import.meta.env.VITE_TG_BOT_USERNAME ?? 'MolePinEventBot';

// ---- 소셜: X ----
export const X_HANDLE: string = import.meta.env.VITE_X_HANDLE ?? 'molepinhq';

// ---- 후원 ----
// EOA(개인 지갑)이므로 Ethereum / BNB Chain / Polygon 이 동일 주소를 공유한다.
// (같은 개인키가 세 체인 모두를 제어)
// 나중에 멀티시그로 옮길 때 .env 만 바꿔 재빌드하면 되도록 분리해 둔다.
export const DONATE_ADDRESS: string =
  import.meta.env.VITE_DONATE_ADDRESS ?? '0xe146875c49F06AabC86f6CaF273c7858d988eEC8';